import {
    getCustomer,
    listCustomers
} from './queries';
import {
    createCustomer,
    deleteCustomer,
    purgeCustomer,
    updateCustomer,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    Customer,
    CreateCustomer,
    DeleteCustomer,
    GetCustomer,
    ListCustomers,
    UpdateCustomer
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery & { statusFilter?: string | null }) => {
    try {
        const filter = query.statusFilter ? { status: query.statusFilter } : undefined;

        const response = await client.graphql<GraphQLQuery<ListCustomers>>(
            {
                query: listCustomers,
                variables: {
                    ...query,
                    filter
                },
            });

        return {
            items: response.data?.listCustomers.items,
            nextToken: response.data?.listCustomers.nextToken,
        };

    } catch (e: unknown) {
        const err = e as Record<string, unknown>;
        if (typeof err !== 'undefined' && typeof err.errors !== 'undefined') {
            const unauthorizedExceptionFound = (err.errors as Array<{errorType: string, message: string}>).find((item: {
                errorType: string,
                message: string
            }) => item.errorType === 'UnauthorizedException')
            if (unauthorizedExceptionFound) {
                window.location.href = '/'
            }
        }
        throw e;
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetCustomer>>(
        {
            query: getCustomer,
            variables: {id: id},
        });
    return response.data?.getCustomer;
};

export const add = async (payload: Omit<Customer, 'id'> & Record<string, unknown>) => {
    const cleanPayload = {
        ...payload,
        contactInfo: payload.contactInfo ? {
            ...payload.contactInfo,
            phone: payload.contactInfo.phone || null,
            website: payload.contactInfo.website || null
        } : payload.contactInfo
    };

    const response = await client.graphql<GraphQLQuery<CreateCustomer>>(
        {
            query: createCustomer,
            variables: {input: cleanPayload},
        });
    console.debug('in the service response', response);
    return response.data?.createCustomer;
};

export const update = async (id: string, record: Customer) => {

    console.debug('IN UPDATE', id, record);

    const {
        createdByUsername: _createdByUsername,
        createdByUser: _createdByUser,
        created: _created,
        updated: _updated,
        ...rest
    } = record

    const cleanRest = {
        ...rest,
        contactInfo: rest.contactInfo ? {
            ...rest.contactInfo,
            phone: rest.contactInfo.phone || null,
            website: rest.contactInfo.website || null
        } : rest.contactInfo
    };

    const response = await client.graphql<GraphQLQuery<UpdateCustomer>>(
        {
            query: (updateCustomer),
            variables: {input: cleanRest},
        });
    return response.data?.updateCustomer;
};

export const purgeRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteCustomer>>({
        query: purgeCustomer,
        variables: {input: {id: id}},
    });
    return response.data?.deleteCustomer;
};

export const archiveRecord = async (id: string) => {
    const customer = await fetch(id);
    if (customer) {
        const updatedCustomer = {
            ...customer,
            status: 'ARCHIVED' as const
        };
        return await update(id, updatedCustomer);
    }
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteCustomer>>(
        {
            query: (deleteCustomer),
            variables: {input: {id: id}},

        });
    return response.data?.deleteCustomer;
};
